module.exports = __webpack_public_path__ + "img/turnover.43b485cd.png";